import { useEffect } from 'react';

const getDomain = () => {
  const url = globalThis.location.origin;
  if (url.includes('.cubesit2.')) {
    return 'cubesit2';
  }
  if (url.includes('.cubesit.')) {
    return 'cubesit';
  }
  if (url.includes('.cubeqa1.')) {
    return 'cubeqa1';
  }
  if (url.includes('.cubeqa2.')) {
    return 'cubeqa2';
  }
  if (url.includes('.cubeqa.')) {
    return 'cubeqa';
  }
  if (url.includes('.cubeuat.')) {
    return 'cubeuat';
  }
  if (url.includes('.cubedev2.')) {
    return 'cubedev2';
  }
  if (url.includes('.cube.')) {
    return 'cube';
  }
  return 'cubedev';
};

const useNotificationListener = () => {
  useEffect(() => {
    const handleCNHPipelineEvent = (event) => {
      const payload = event.detail;
      const encodedData = encodeURIComponent(JSON.stringify(payload));
      globalThis.location.href = `https://one.pipeline.${getDomain()}.toyota.com/pipeline/vehicle-list?notificationDetails=${encodedData}`;
    };

    globalThis.addEventListener('cnh:action-view-pipeline', handleCNHPipelineEvent);

    return () => {
      globalThis.removeEventListener('cnh:action-view-pipeline', handleCNHPipelineEvent);
    };
  }, []);
};

export default useNotificationListener;
